import code from './code.svg';
import screenMini from './screen-mini.svg';
import analytics from './analytics.svg';
import twentyFourSeven from './24-7.svg';
import mic from './mic.svg';
import barsExtended from './bars-extended.svg';

export default {
  code,
  screenMini,
  analytics,
  twentyFourSeven,
  mic,
  barsExtended,
};



// WEBPACK FOOTER //
// ./src/img/features/index.js